export default {
  'environment.manageModal.title': 'Environment Management',
  'environmentDetail.label.server': 'Service (prefix URL) ',
  'environmentDetail.label.variables': 'Environment Variables',
  'environment.title.variableName': 'Variable',
  'environment.title.variableName.placeholder': 'Add a new variable',
  'environment.title.addVariableValue': 'Add Variable',
  'environment.title.value': 'Value',
  variableNameEmptyError: 'Name is required',
  preFixUrl: 'Prefix Url',
  'editor.tip': 'The data format follows',
  filedBulkEdit: 'Bulk Edit',
  'environment.title.serviceName': 'Service Name',
};
